import * as _ from "underscore";
import * as ko from "knockout";

import { IForm, IScreen } from "Core/Screens/IScreen";
import {ScreenTypes} from 'Core/Common/Enums/ScreenTypes';
import { BlockUI } from "../Index";
import {FlowFolderPopover} from "Core/Components/FlowFolderPopover/FlowFolderPopover";

import Template from 'Core/Controls/Grid/BaseGrid/GridRow/Templates/GridScreenRow.html';
ko.templates['Core/Controls/Grid/BaseGrid/GridRow/Templates/GridScreenRow'] = Template;

export class GridScreenRow{
    private _screen: KnockoutObservable<IScreen>;
    private __screen: IScreen;
    private _el: HTMLElement;
    private _form: IForm;
    private _recordId: number;


    constructor(screen: IScreen, form: IForm, recordId: number){
        this._screen = ko.observable(null);
        this.__screen = screen;
        this._recordId = recordId;
        this._form = form;   
    }

    async LoadScreenData(){
        const screenManager = (await import('Core/ScreenManager/ScreenManager')).ScreenManager;
        let screen = await screenManager.GetScreenById({ ScreenId: this.__screen.GetScreenId(), RecordId: this._recordId });
        screen.SourceScreen = this._form && this._form.GetScreen().GetType();
        this._screen(screen);
        this.__screen = screen;
    }

    FlowFolderPopoverDestroy(element: HTMLElement): void {
        FlowFolderPopover.Instance.Destroy(element);
    }

    AfterRender(elements: Array<HTMLElement>){
        this._el = _.find(elements, el=>el.nodeType === 1);
    }

    GetTemplateName(){
        return 'Core/Controls/Grid/BaseGrid/GridRow/Templates/GridScreenRow';
    }
    
    get Screen():IScreen {
        return this.__screen;
    }
    
}